import { useState, useCallback } from 'react';
import ENDPOINTS from '../api/endpoints';
import { INTEGRATIONS_BASE_URL } from '../api/config';
import { FormData } from './useCheckoutForm';
import { getRestaurantId } from '../api/tokenUtils';

interface DeliveryQuote {
  id: string;
  fee: number;
  currency: string;
  dropoff_eta: string;
  expires: string;
}

export const useDelivery = () => {
  const [isLoadingQuote, setIsLoadingQuote] = useState(false);
  const [deliveryQuote, setDeliveryQuote] = useState<DeliveryQuote | null>(null);
  const [isQuotePopupOpen, setIsQuotePopupOpen] = useState(false);
  
  const fetchDeliveryQuote = useCallback(async (customerFormData: FormData) => {
    setIsLoadingQuote(true);
    
    const restaurantId = getRestaurantId();
    
    const formatPhoneNumber = (phone: string) => {
      const cleaned = phone.replace(/\D/g, '');
      return cleaned.startsWith('1') ? `+${cleaned}` : `+1${cleaned}`;
    };
    
    try {
      const response = await fetch(`${INTEGRATIONS_BASE_URL}${ENDPOINTS.UBER_DIRECT_QUOTE_API_PATH}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'restaurant-id': restaurantId || '',
        },
        body: JSON.stringify({
          dropoffAddress: {
            street_address: [customerFormData.address_line_1 || ''],
            city: customerFormData.locality || '',
            state: customerFormData.administrative_district_level_1 || '',
            zip_code: customerFormData.postal_code || '',
            country: customerFormData.country || 'US',
          },
          latitude: 0,
          longitude: 0,
          customerPhone: formatPhoneNumber(customerFormData.phone || ''),
          customerName: customerFormData.name,
        }),
      });

      const data = await response.json();

      if (data?.success && data?.data) {
        setDeliveryQuote(data.data);
        setIsQuotePopupOpen(true);
      }
    } catch (err: any) {
      console.error('Quote error:', err);
    } finally {
      setIsLoadingQuote(false);
    }
  }, []);

  return {
    fetchDeliveryQuote,
    isLoadingQuote,
    deliveryQuote,
    isQuotePopupOpen,
    setIsQuotePopupOpen,
  };
};
